import React, { useContext } from "react";

import {
  LearnHero,
  LearnPodcasts,
  LearnOurArticles,
  LearnVideos,
} from "../../components/LearnComponents";
import GetOnBoard from "../../components/ContentComponents/GetOnBoard";
import SubscribeBanner from "../../components/SubscribeBanner";

import { getAcfPartialContent } from "../../utils";

import "./style.scss";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";

const LearnLayout = ({ data }) => {
  const { t, lang } = useContext(CustomI18nextContext);

  const isThaiLang = lang === "th";

  return (
    <>
      <LearnHero
        content={data.heroContent.edges[0].node.acfHeroSections}
        menuIcon={data.learnIcon}
        menuName={t("menu.learn.title")}
      />

      <LearnOurArticles
        categories={data.articleCategories.nodes[0]?.wpChildren.nodes}
        posts={data.articles.nodes}
        t={t}
        lang={lang}
      />

      {isThaiLang && <LearnPodcasts posts={data.podcasts.nodes} t={t} />}

      <SubscribeBanner
        content={getAcfPartialContent(data.subscribeBannerContent)}
      />

      <LearnVideos
        t={t}
        playlists={data.youtubeLinks.nodes}
        channel={data.youtubeChannel.nodes[0].acfPartials}
      />
      <GetOnBoard content={getAcfPartialContent(data.getOnBoardContent)} />
    </>
  );
};

export default LearnLayout;
